import Vue from 'vue'
import App from './App.vue'
import store from './store/'
import router from './router'
import { Button, message, Icon } from 'ant-design-vue';
Vue.use(Button)
Vue.use(Icon)
Vue.config.productionTip = false
Vue.prototype.$message = message
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
